<!--
 * @Author: Dzy
 * @Date: 2022-08-02 17:12:15
 * @LastEditors: Dzy
 * @LastEditTime: 2022-11-07 19:35:20
 * @Description: 登录页面
-->
<template>
  <a-layout>
    <a-layout-content>
      <a-row align="middle" class="login-layout">
        <a-col flex="600px" class="login-left">
          <img class="loginImg" :src="loginImg" alt="" />
          <div class="copyright">
            <!-- &copy; {{ year }} {{t('views.login.爱动力科技')}} -->
          </div>
        </a-col>
        <a-col flex="auto" class="login-right">
          <div class="user-layout-login">
            <a-typography-title :level="2">{{ title }}</a-typography-title>
            <div class="spinLoading" v-if="authLoading">
              <a-spin size="large" :tip="t('views.login.登录鉴权中')" />
            </div>
            <div v-else class="form">
              <a-form :model="formParams" :rules="rules" @finish="handleFinish" :labelCol="formStyle.labelCol"
                :wrapperCol="formStyle.wrapperCol">
                <a-form-item name="accountNum">
                  <a-input v-model:value="formParams.accountNum" size="large"
                    :placeholder="t('inputPlaceholder.请输入用户名（账号 或 手机号）')">
                    <template #prefix>
                      <UserOutlined />
                    </template>
                  </a-input>
                </a-form-item>
                <a-form-item name="password">
                  <a-input-password v-model:value="formParams.password" size="large"
                    :placeholder="t('inputPlaceholder.请输入密码')">
                    <template #prefix>
                      <LockOutlined />
                    </template>
                  </a-input-password>
                </a-form-item>
                <a-form-item name="code" style="text-align: left">
                  <a-input v-model:value="formParams.code" style="width: 160px" size="large" autocomplete="off"
                    :placeholder="t('inputPlaceholder.请输入验证码')" :style="{ verticalAlign: 'middle' }">
                    <template #prefix>
                      <VerifiedOutlined />
                    </template>
                  </a-input>
                  <img v-show="captcha.imgUrl" class="imgVerification" @click="loadCaptcha" :src="captcha.imgUrl"
                    :style="{ verticalAlign: 'middle' }" />
                </a-form-item>
                <a-button size="large" type="primary" html-type="submit" :loading="loginLoading" :block="true">
                  {{ t('views.login.登录') }}
                </a-button>
              </a-form>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-layout-content>
    <div class="ysbt">
      <a-dropdown>
        <template #overlay>
          <a-menu @click="handleMenuClick">
            <a-menu-item @click="changeLanguage('zh_cn')">{{
              t('views.login.简体中文')
            }}</a-menu-item>
            <a-menu-item @click="changeLanguage('zh_tw')">{{
              t('views.login.繁體中文')
            }}</a-menu-item>
            <a-menu-item @click="changeLanguage('en_us')">{{ t('views.login.英语') }}</a-menu-item>
          </a-menu>
        </template>
        <a-button>
          <template v-if="language == 'zh_cn'">{{ t('views.login.简体中文') }}</template>
          <template v-if="language == 'zh_tw'">{{ t('views.login.繁體中文') }}</template>
          <template v-if="language == 'en_us'">{{ t('views.login.英语') }}</template>
          <DownOutlined />
        </a-button>
      </a-dropdown>
      <!-- <a-button @click="changeLanguage">{{language=="zh_cn"?t('views.login.繁體中文'):t('views.login.简体中文')}}</a-button> -->
    </div>
    <div style="width: 100%; z-index: 9999; display: flex; justify-content: center">
      <a class="linkPolice" href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025149099号</a>
    </div>
    <div v-show="false">V2.2.0.7-busi</div>
  </a-layout>
</template>
<script setup>
import { UserOutlined, LockOutlined, VerifiedOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { storeToRefs } from 'pinia'
import useStore from '@/store'
import useBuildUinfos from '@com/auth/useBuildUinfos'
import useSwitchOrg from '@com/auth/useSwitchOrg'
import { useRouter, useRoute } from 'vue-router'
import useCaptcha from './comspoables/useCaptcha'
import useLogin from './comspoables/useLogin'
import { ref, computed, onBeforeMount, watch } from 'vue'
import useSwitchRole from '@com/auth/useSwitchRole'
import { clearStorage } from '@tools'
import { QINIU_BASE_URL } from '@Con'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()
const { auth, config, userToken } = useStore()
const { uinfo, allAccounts } = storeToRefs(auth)
const { title, loginImg, icon, language } = storeToRefs(config)
const router = useRouter()
const year = new Date().getFullYear()
const route = useRoute()
const query = route.query

// 验证码模块导入
const { captcha, loadCaptcha } = useCaptcha()
// 鉴权模块导入
const { formParams, doLogin, loginLoading, doLoginToken } = useLogin(userToken)
const { getUinfoByToken } = useBuildUinfos(auth, userToken)
const { switchOrg } = useSwitchOrg(auth)
const { switchAndBuildMenus } = useSwitchRole(auth)

const rules = {
  accountNum: [
    { required: true, message: t('inputRequired.请填写登录用户名') }
    // { min: 3, max: 50, message: '用户名长度为3-50字符', trigger: 'blur' },
  ],
  password: [
    { required: true, message: t('inputRequired.请填写登录密码') },
    {
      pattern: /^[^\u4e00-\u9fa5]+$/,
      message: t('inputRequired.登录密码格式仅支持大小写字母、数字及特殊符号'),
      trigger: ['blur', 'change']
    }
    // { min: 6, max: 20, message: '密码长度为6-20字符', trigger: 'blur' },
  ],
  code: [{ required: true, message: t('inputRequired.请填写验证码') }]
}

const changeLanguage = (changel) => {
  if (language.value != changel) {
    config.update_language(changel)
  }
}

const formStyle = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 }
}

const jumpIn = async () => {
  router.push('/myInfo/base')
}

// 事件响应方法
const handleFinish = async () => {
  loginLoading.value = true
  try {
    await doLogin(captcha.value)
    const result = await getUinfoByToken()

    if (result == 1) {
      if (allAccounts.value.length == 1 && allAccounts.value[0].roles.length == 1) {
        // 1. accounts 只有一个 ，直接 switchOrg 进入菜单
        const switchResult = await switchOrg(
          allAccounts.value[0].orgId,
          true,
          allAccounts.value[0].tenantOrgId
        )
        if (switchResult === 1) {
          // 认证通过
          if (
            uinfo.value.menuTree &&
            uinfo.value.menuTree.length &&
            uinfo.value.menuTree[0].defaultPath
          ) {
            loginLoading.value = false
            router.push(uinfo.value.menuTree[0].defaultPath)
          } else {
            loginLoading.value = false
            message.warn(t('message.没有任何可用的角色权限信息，请联系管理员处理！'))
            formParams.value = {
              ...formParams.value,
              code: ''
            }
            loadCaptcha()
            clearStorage()
          }
        } else {
          loginLoading.value = false
        }
      } else {
        const switchResult = await switchOrg(
          allAccounts.value[0].orgId,
          false,
          allAccounts.value[0].tenantOrgId
        )
        if (switchResult === 2) {
          if (allAccounts.value.length == 1 && allAccounts.value[0].roles.length == 1) {
            const switchResult = await switchAndBuildMenus(
              allAccounts.value[0].accountId,
              allAccounts.value[0].roles[0].roleId,
              allAccounts.value[0].tenantOrgId
            )
            if (switchResult === 1) {
              // 认证通过
              if (
                uinfo.value.menuTree &&
                uinfo.value.menuTree.length &&
                uinfo.value.menuTree[0].defaultPath
              ) {
                loginLoading.value = false
                router.push(uinfo.value.menuTree[0].defaultPath)
              } else {
                loginLoading.value = false
                message.warn(t('message.没有任何可用的角色权限信息，请联系管理员处理！'))
                formParams.value = {
                  ...formParams.value,
                  code: ''
                }
                loadCaptcha()
                clearStorage()
              }
            } else {
              loginLoading.value = false
            }
          }
          // 2. 进入个人中心
          else {
            loginLoading.value = false
            jumpIn()
          }
        } else {
          loginLoading.value = false
        }
      }
    } else {
      loginLoading.value = false
    }
  } catch (e) {
    loginLoading.value = false
    formParams.value = {
      ...formParams.value,
      code: ''
    }
    loadCaptcha()
    clearStorage()
    message.warn(e.message)
  }
}

const authLoading = ref(false)

onBeforeMount(async () => {
  await loadCaptcha()
  // 第三方token 登录平台
  if (query.token) {
    await doLoginToken(query)
  }
  const userTokenBusi = JSON.parse(localStorage.getItem('userTokenBusi'))

  if (userTokenBusi && userTokenBusi.accessToken && userTokenBusi.tokenType) {
    authLoading.value = true
    try {
      const result = await getUinfoByToken()

      if (result == 1) {
        if (uinfo && uinfo.value.menuTree && uinfo.value.menuTree.length) {
          if (query.rt) {
            router.push(query.rt)
          } else {
            if (
              uinfo.value.menuTree &&
              uinfo.value.menuTree.length &&
              uinfo.value.menuTree[0].defaultPath
            ) {
              router.push(uinfo.value.menuTree[0].defaultPath)
            } else {
              message.warn(t('message.没有任何可用的角色权限信息，请联系管理员处理！'))
              formParams.value = {
                ...formParams.value,
                code: ''
              }
              loadCaptcha()
              clearStorage()
            }
          }
        } else {
          if (allAccounts.value.length == 1 && allAccounts.value[0].roles.length == 1) {
            // 1. accounts 只有一个 ，直接 switchOrg 进入菜单
            const switchResult = await switchOrg(
              allAccounts.value[0].orgId,
              true,
              allAccounts.value[0].tenantOrgId
            )
            if (switchResult === 1) {
              // 认证通过
              if (query.rt) {
                router.push(query.rt)
              } else {
                if (
                  uinfo.value.menuTree &&
                  uinfo.value.menuTree.length &&
                  uinfo.value.menuTree[0].defaultPath
                ) {
                  router.push(uinfo.value.menuTree[0].defaultPath)
                } else {
                  message.warn(t('message.没有任何可用的角色权限信息，请联系管理员处理！'))
                  formParams.value = {
                    ...formParams.value,
                    code: ''
                  }
                  loadCaptcha()
                  clearStorage()
                }
              }
            }
          } else {
            const switchResult = await switchOrg(
              allAccounts.value[0].orgId,
              false,
              allAccounts.value[0].tenantOrgId
            )
            if (switchResult === 2) {
              if (allAccounts.value.length == 1 && allAccounts.value[0].roles.length == 1) {
                const switchResult = await switchAndBuildMenus(
                  allAccounts.value[0].accountId,
                  allAccounts.value[0].roles[0].roleId,
                  allAccounts.value[0].tenantOrgId
                )
                if (switchResult === 1) {
                  // 认证通过
                  if (query.rt) {
                    router.push(query.rt)
                  } else {
                    if (
                      uinfo.value.menuTree &&
                      uinfo.value.menuTree.length &&
                      uinfo.value.menuTree[0].defaultPath
                    ) {
                      router.push(uinfo.value.menuTree[0].defaultPath)
                    } else {
                      message.warn(t('message.没有任何可用的角色权限信息，请联系管理员处理！'))
                      formParams.value = {
                        ...formParams.value,
                        code: ''
                      }
                      loadCaptcha()
                      clearStorage()
                    }
                  }
                }
              }
              // 2. 进入个人中心
              else jumpIn()
            }
          }
        }
      }
    } catch (e) {
      message.warn(e.message)
      setTimeout(() => (authLoading.value = false), 500)
    }
  }
})
</script>
<style lang="less" scoped>
.login-layout {
  width: 100vw;
  height: 100vh;

  .login-left {
    position: relative;
    height: 100%;
    width: 600px;
    background-size: contain;
    background-color: @primary-color;
    display: flex;
    flex-direction: row;

    >img {
      object-fit: contain;
      flex: 1;
      overflow: hidden;
    }

    .copyright {
      position: absolute;
      bottom: 30px;
      text-align: center;
      width: 100%;
      color: @text-color-inverse;
    }
  }

  .login-right {
    height: 100%;
    background: #fff;
    display: flex;

    .user-layout-login {
      height: 472px;
      width: 440px;
      padding: 60px 0 0 0;
      text-align: center;
      margin: auto;
      border-radius: 4px;
      box-shadow: 0px 10px 30px 0px rgba(46, 67, 107, 0.1);

      .form {
        display: flex;
        justify-content: center;
        padding: 30px 60px 0 60px;
        height: 300px;

        >.ant-form {
          width: 100%;
        }

        .ant-btn {
          margin-top: 20px;
        }

        .imgVerification {
          height: 40px;
          width: 140px;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .spinLoading {
        padding-top: calc(100% - 350px);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.ant-input-prefix .anticon {
  color: #1890ff;
}

.ysbt {
  position: fixed;
  right: 32px;
  top: 16px;
}

.linkPolice {
  color: #c0c0c0;
}

.linkPolice:hover {
  color: #40a9ff;
}
</style>
